<mat-toolbar color="primary" class="action-toolbar">
    <h3>Patient Filters</h3>
    <!--
      Risk-register actions, on the toolbar rather than inside the tab
      (`billing-view.component.html:1-40`).

      `matMenuTriggerFor` takes a MatMenu INSTANCE, so these triggers open panels that live in
      `risk-management-list` — the filters and the export keep their state in the component that
      owns the register, and this generic five-tab host stays free of risk-specific state.

      Gated on the tab being ACTIVE: a toolbar button that acted on a list the user cannot see
      would export a filtered set they were not looking at.
    -->
    <div class="toolbar-actions" *ngIf="isRiskTabActive && riskList">
        <button mat-icon-button [matMenuTriggerFor]="riskList.filterMenu"
            [matTooltip]="riskList.hasActiveFilters
                ? 'Filters (' + riskList.activeFilterCount + ' active)'
                : 'Filter the risk register'">
            <!-- accent when filtered, exactly as the coding view signals it. -->
            <mat-icon [color]="riskList.hasActiveFilters ? 'accent' : 'primary'">filter_list</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="riskList.exportMenu"
            [disabled]="riskList.exporting || !riskList.filteredItems.length"
            [matTooltip]="riskList.exporting
                ? 'Generating…'
                : 'Export the filtered register (' + riskList.filteredItems.length + ')'">
            <mat-icon color="primary">picture_as_pdf</mat-icon>
        </button>
    </div>
</mat-toolbar>

<div class="patient-list-container">

    <div class="filter-wrapper">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="filterValue" (keyup)="applyFilter($event)" placeholder="Search patients"
                #input>
            <mat-icon matSuffix *ngIf="!filterValue">search</mat-icon>
            <mat-icon matSuffix *ngIf="filterValue" (click)="filterValue = ''" class="clickable">close</mat-icon>
            <mat-hint>Search by name, surname, patient number, procedure, tag, task, or risk item</mat-hint>
        </mat-form-field>
    </div>

    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabId" class="tab-group"
        matTabGroupGesture [swipeLimitWidth]="80" [connectEdges]="true">
        <mat-tab>
            <ng-template mat-tab-label>
                Task List ({{totalTasks || 0}})
            </ng-template>
            <div class="tab-content">
                <app-task-list [filterValue]="filterValue"></app-task-list>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Patient Tags ({{totalTags || 0}})
            </ng-template>
            <div class="tab-content">
                <app-tags-list [filterValue]="filterValue"></app-tags-list>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Logbook ({{totalLogbook || 0}})
            </ng-template>
            <div class="tab-content">
                <app-logbook-list [filterValue]="filterValue"></app-logbook-list>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Risk Management ({{totalRiskItems || 0}})
            </ng-template>
            <div class="tab-content">
                <app-risk-management-list [filterValue]="filterValue"></app-risk-management-list>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Morbidity & Mortality ({{totalMorbidityMortality || 0}})
            </ng-template>
            <div class="tab-content">
                <app-morbidity-mortality-list [filterValue]="filterValue"></app-morbidity-mortality-list>
            </div>
        </mat-tab>
    </mat-tab-group>

</div>